import { render, staticRenderFns } from "./MRMenu.vue?vue&type=template&id=f07751a0&"
import script from "./MRMenu.vue?vue&type=script&lang=js&"
export * from "./MRMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports